module.exports = __webpack_public_path__ + "img/moon.0dfe0d10.jpg";